import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEVLSICoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. VLSI Engineering",
    shortName: "B.E. VLSI",
    duration: "4 Years",
    description: "Study Very Large Scale Integration (VLSI) design, semiconductor devices, and microelectronics.",
    overview: "Bachelor of Engineering in VLSI Engineering is a 4-year undergraduate program focused on integrated circuit design, semiconductor technology, digital systems, and microelectronics. The course prepares students for careers in chip design, embedded systems, and semiconductor industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Valid entrance exam score (JEE Main/State CET)",
      "Interest in electronics and microchip design"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Basic Electronics",
          "Engineering Graphics",
          "Introduction to VLSI"
        ]
      },
      {
        year: 2,
        subjects: [
          "Digital Electronics",
          "Analog Electronics",
          "Semiconductor Devices",
          "Signals and Systems",
          "Microprocessors",
          "Electronic Circuits"
        ]
      },
      {
        year: 3,
        subjects: [
          "VLSI Design",
          "Digital System Design",
          "Embedded Systems",
          "FPGA Design",
          "EDA Tools",
          "ASIC Design"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced VLSI Architectures",
          "Nanoelectronics",
          "Project Work/Internship",
          "Research Seminar"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "VLSI Design Engineer",
        "Chip Design Engineer",
        "Embedded Systems Engineer",
        "FPGA Engineer",
        "Semiconductor Analyst",
        "Verification Engineer"
      ],
      industries: [
        "Semiconductor Companies",
        "Electronics Design Firms",
        "Embedded Systems",
        "Research Organizations",
        "IT Hardware"
      ],
      averageSalary: "₹4-9 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "Intel",
        "Texas Instruments",
        "Qualcomm",
        "Samsung",
        "Cadence",
        "Synopsys",
        "Microchip"
      ]
    },
    admissionProcess: [
      "JEE Main/State CET",
      "Counseling and seat allocation",
      "Direct admission based on 12th marks (in some colleges)"
    ],
    topColleges: [
      {
        name: "IIT Madras",
        location: "Chennai",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "NIT Trichy",
        location: "Trichy",
        fees: "₹5,00,000",
        ranking: "NIRF Ranking: 8"
      },
      {
        name: "VIT Vellore",
        location: "Vellore",
        fees: "₹7,00,000",
        ranking: "Private Top"
      }
    ],
    skills: [
      "VLSI Design",
      "Digital System Design",
      "EDA Tools",
      "FPGA Programming",
      "Embedded Systems",
      "Semiconductor Physics",
      "Project Management"
    ],
    futureScope: "High demand in semiconductor, electronics, and embedded systems industries. Opportunities in research, chip design, and hardware startups.",
    faqs: [
      {
        question: "What is VLSI?",
        answer: "VLSI stands for Very Large Scale Integration, the process of creating integrated circuits by combining thousands of transistors into a single chip."
      },
      {
        question: "Is coding required?",
        answer: "Yes, knowledge of hardware description languages (HDL) like Verilog/VHDL is essential."
      },
      {
        question: "Can I work abroad after this course?",
        answer: "Yes, VLSI engineers are in demand globally, especially in semiconductor hubs."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEVLSICoursePage;